import { Box, Grid } from '@mui/material';
import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import RectangleBox from 'src/components/Compliance/RectangleBox';
import { ROUTES } from 'src/constants/routes';
import BadgeImg from '../../assets/images/GreenStairs.png';
import RedExclamationMark from '../../assets/images/RedExclamationMark.png';
import ErrorCircle from '../../assets/images/error_24px.svg';
import { MessageBox } from '../Compliance';
import Logomark from '../../assets/images/Logomark.png';
import React from 'react';
import Container from '../Container';

const NoPolicyLocated = () => {
  const coverages = [
    'Active Policy',
    'Correct Address',
    'Personal Liability Coverage',
    'Personal Property Coverage',
    // REN-2607 - temporarily not required
    // 'Medical Coverage',
  ];
  return (
    <Container smPaddings={true}>
      <ConfirmationWithBackButton
        icon={RedExclamationMark}
        title="Sorry, we were unable to locate your policy."
        subtitle="We cannot verify your policy at this time. Please contact us using the link below and provide us with a copy of your insurance policy directly."
        image={BadgeImg}
        goBackLink={ROUTES.COMPLIANCE_WELCOME_PATH}
        message={(
          <Grid container margin="auto" justifyContent="center">
            <Grid item xs={12} md={9} lg={7}>
              <Grid container flexDirection="column" gap={3}>
                <RectangleBox
                  statusIcon={
                    <img
                      src={ErrorCircle}
                      height="30px"
                      width="30px"
                      alt="ErrorCircle"
                    />
                  }
                  propertyName="We could not find your policy"
                  propertyValue="There is problem locating your policy."
                />
                {coverages.map((coverageText) => (
                  <div key={coverageText} style={{ opacity: 0.6 }}>
                    <RectangleBox
                    statusIcon={
                        <img
                          src={ErrorCircle}
                          height="30px"
                          width="30px"
                          alt="ErrorCircle"
                        />
                      }
                      propertyName={coverageText}
                      propertyValue=""
                    />
                  </div>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
        bottomMessage={(
          <Box mt={4}>
            <MessageBox
              image={Logomark}
              title="Still have questions?"
              fullWidth={true}
              maxWidth="870px"
              noPolicyLocatedPage={true}
            />
          </Box>
        )}
      />
    </Container>
  );
};

export default NoPolicyLocated;
